import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginComponent } from './login/login.component';
import { CreateaccountComponent } from './createaccount/createaccount.component';
import { AccountComponent } from './account/account.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { RegisterBusinessComponent } from './register-business/register-business.component';
import { ApiService } from '../services/api.service';
import { HttpClientModule } from '@angular/common/http';
import { NgxMaskModule } from 'ngx-mask';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoginDetailsComponent } from './login-details/login-details.component';
import { TwofactorLoginComponent } from './twofactor-login/twofactor-login.component';
import { SharedModule } from '../shared/module/shared.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RegisterBusinessModelComponent } from './shared/popups/register-business-model/register-business-model.component';
import { IdmeVerificationComponent } from './idme-verification/idme-verification.component';
import { VerificationPopupComponent } from './shared/popups/verification-popup/verification-popup.component';
import { CheckIdmeComponent } from './check-idme/check-idme.component';
import { PendingVerificationComponent } from './pending-verification/pending-verification.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PasswordForgotComponent } from './shared/popups/password-forgot/password-forgot.component';
import { ErrorComponent } from './error/error.component';
import { UnverifiedBusinessComponent } from './unverified-business/unverified-business.component';
import { LinkExpiredComponent } from './link-expired/link-expired.component';
import { BusinessesComponent } from './businesses/businesses.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UploadPhotoComponent } from './upload-photo/upload-photo.component';
import { TermsAndConditionComponent } from '../shared/terms-and-condition/terms-and-condition.component';
import { ContactUsComponent } from '../shared/contact-us/contact-us.component';
import { TermsAndConditionssPageComponent } from '../shared/terms-and-conditionss-page/terms-and-conditionss-page.component';
import { ConfirmComponent } from '../dashboard/shared/popups/confirm/confirm.component';
import { InvitedUsersComponent } from './invited-users/invited-users.component';
import { ServerInfoComponentComponent } from '../shared/server-info-component/server-info-component.component';
import { PasswordWarningComponent } from '../shared/password-warning/password-warning.component';
import { ReCaptchaComponent } from './shared/popups/re-captcha/re-captcha.component';
import { StandaloneHeaderComponent } from './shared/standalone-header/standalone-header.component';
import { AgreementComponent } from './agreement/agreement.component';
import { ViewNotificationsComponent } from './view-notifications/view-notifications.component';
import { ViewMessageComponent } from './shared/view-message/view-message.component';
// import { UnAuthComponent } from '../shared/un-auth/un-auth.component';

import { HistoryLabComponent } from '../shared/history-lab/history-lab.component';
import { PrintQRComponent } from '../dashboard/shared/popups/print-qr/print-qr.component';
import { AddDeliveryAddressComponent } from '../shared/popup/add-delivery-address/add-delivery-address.component';
import { SidescreenComponent } from './shared/sidescreen/sidescreen.component';
import { EditUserDashboardComponent } from '../shared/popup/edit-user-dashboard/edit-user-dashboard.component';

import { AddNewFileComponent } from '../dashboard/shared/popups/add-new-file/add-new-file.component';
import {AddMultipleDocsComponent} from '../dashboard/shared/popups/add-multiple-docs/add-multiple-docs.component';
import { AddNewFolderComponent } from '../dashboard/shared/popups/add-new-folder/add-new-folder.component';
import { DeleteVerificationComponent } from '../dashboard/shared/popups/delete-verification/delete-verification.component';
import { ShareDocComponent } from '../dashboard/shared/popups/share-doc/share-doc.component'
import { SharingGroupComponent } from '../dashboard/shared/popups/sharing-group/sharing-group.component';
import { AddBusinessComponent } from '../dashboard/shared/popups/add-business/add-business.component';
import { AddNoteComponent } from '../dashboard/shared/popups/add-note/add-note.component';
import { FileMenuComponent } from '../dashboard/shared/file-menu/file-menu.component';
import { EditDocComponent } from '../dashboard/shared/popups/edit-doc/edit-doc.component';
import { EditFolderComponent } from '../dashboard/shared/popups/edit-folder/edit-folder.component';
import { MoveDocComponent } from '../dashboard/shared/popups/move-doc/move-doc.component';
import { AuthMessageComponent } from './auth-message/auth-message.component';
import { FileHistoryComponent } from 'src/app/dashboard/shared/popups/file-history/file-history.component';
import { KeywordDialogComponent } from 'src/app/dashboard/shared/popups/keyword-dialog/keyword-dialog.component';
import { UniversalAppComponent } from './universal-app/universal-app.component';
import { IdentityVerificationComponent } from './identity-verification/identity-verification.component';
import { ViewTaskManagementComponent } from './view-task-management/view-task-management.component';

@NgModule({
  declarations: [
    LoginComponent
    // , RegistrationComponent
    , CreateaccountComponent
    , VerificationPopupComponent
    , AccountComponent
    // , RegisterComponent
    , HeaderComponent
    , FooterComponent
    , RegisterBusinessComponent
    , LoginDetailsComponent
    , TwofactorLoginComponent
    , ForgotPasswordComponent
    , RegisterBusinessModelComponent
    , IdmeVerificationComponent
    , CheckIdmeComponent
    , PendingVerificationComponent
    , PasswordForgotComponent
    , ErrorComponent
    , UnverifiedBusinessComponent
    , LinkExpiredComponent
    , BusinessesComponent
    , UserProfileComponent
    , UploadPhotoComponent
    , InvitedUsersComponent
    , ReCaptchaComponent
    , StandaloneHeaderComponent
    , AgreementComponent
    , ViewNotificationsComponent
    , ViewMessageComponent
    , SidescreenComponent
    , AuthMessageComponent, UniversalAppComponent, IdentityVerificationComponent, ViewTaskManagementComponent
     // ,AddNewFileComponent
    // ,AddNewFolderComponent
    // ,DeleteVerificationComponent
    // ,ShareDocComponent
  ],
  providers: [ApiService],
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    HttpClientModule,
    NgxCaptchaModule,
    SharedModule.forRoot(),
    NgxMaskModule.forRoot(),
    ImageCropperModule
  ],
  entryComponents: [
    RegisterBusinessModelComponent,
    VerificationPopupComponent,
    PasswordForgotComponent,
    UploadPhotoComponent,
    TermsAndConditionComponent,
    ContactUsComponent,
    TermsAndConditionssPageComponent,
    ConfirmComponent,
    ServerInfoComponentComponent,
    PasswordWarningComponent,
    ReCaptchaComponent,
    ViewMessageComponent,
    // UnAuthComponent,
    EditUserDashboardComponent,
    HistoryLabComponent,
    PrintQRComponent,
    AddDeliveryAddressComponent
    ,AddNewFileComponent
    ,AddMultipleDocsComponent
    ,AddNewFolderComponent
    ,DeleteVerificationComponent
    ,ShareDocComponent,
    SharingGroupComponent,
    AddBusinessComponent,
    AddNoteComponent,
    FileMenuComponent,
    EditDocComponent,
    EditFolderComponent,
    MoveDocComponent,
    FileHistoryComponent,
    KeywordDialogComponent
  ]
})
export class AuthenticationModule { }
